/* Shopify's teaser-first mode waits for a click. Add one delayed opening,
   using the native button and preserving native dismissal/submission state. */
(() => {
  'use strict';
  const formId = '1190062';
  const seenKey = 'fp-welcome-popup-seen-v1';
  const started = Date.now();
  let timer;
  let stopped = false;
  let observedRoot;

  function stop() {
    stopped = true;
    clearTimeout(timer);
    if (observedRoot) observedRoot.removeEventListener('click', interacted, true);
  }

  function suppressed() {
    try {
      return Boolean(localStorage.getItem(seenKey) ||
        localStorage.getItem(`${formId}-dismissed-after-submit`) ||
        localStorage.getItem(`${formId}-dismissed-in-session`) ||
        localStorage.getItem(`${formId}-minimized-in-session`));
    } catch (_) {
      // Do not automatically interrupt when dismissal preferences cannot persist.
      return true;
    }
  }

  function remember() {
    try { localStorage.setItem(seenKey, '1'); } catch (_) { /* Native controls still work. */ }
    stop();
  }

  function interacted() {
    // Opening or closing the teaser manually cancels the pending automatic opening.
    remember();
  }

  function inspect() {
    if (stopped) return;
    if (suppressed() || Date.now() - started > 60000) return stop();
    const host = document.getElementById(`app-embed-container-${formId}`);
    const root = host && host.shadowRoot;
    if (root && root !== observedRoot) {
      if (observedRoot) observedRoot.removeEventListener('click', interacted, true);
      observedRoot = root;
      root.addEventListener('click', interacted, true);
    }
    const teaser = root && root.querySelector('button[data-testid="form-teaser"]');
    if (teaser && Date.now() - started >= 15000 && document.visibilityState === 'visible') {
      const style = getComputedStyle(teaser);
      if (teaser.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none') {
        remember();
        teaser.click();
        return;
      }
    }
    timer = setTimeout(inspect, 250);
  }
  inspect();
})();


/* Keep the native welcome teaser clear of mobile cart checkout controls. */
(() => {
  'use strict';
  let frame = 0;
  let root;
  let teaser;
  let lift = 0;
  let shift = 0;
  const media = matchMedia('(max-width: 749px)');
  const resizeObserver = new ResizeObserver(schedule);
  const shadowObserver = new MutationObserver(schedule);
  const watched = new WeakSet();

  function watch(element) {
    if (element && !watched.has(element)) {
      resizeObserver.observe(element);
      watched.add(element);
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(position);
  }

  function position() {
    frame = 0;
    const host = document.getElementById('app-embed-container-1190062');
    if (!host || !host.shadowRoot) return;
    if (root !== host.shadowRoot) {
      shadowObserver.disconnect();
      root = host.shadowRoot;
      shadowObserver.observe(root, {childList: true, subtree: true});
      const style = document.createElement('style');
      style.textContent = 'button[data-testid="form-teaser"] { transform: translate(var(--fp-cart-teaser-x, 0px), var(--fp-cart-teaser-y, 0px)); }';
      root.appendChild(style);
    }
    const next = root.querySelector('button[data-testid="form-teaser"]');
    if (!next) return;
    if (next !== teaser) {
      teaser = next;
      lift = 0;
      shift = 0;
      watch(teaser);
    }
    let nextLift = 0;
    let nextShift = 0;
    if (media.matches && teaser.getClientRects().length) {
      const rect = teaser.getBoundingClientRect();
      const baseBottom = rect.bottom + lift;
      const baseLeft = rect.left - shift;
      const drawer = document.querySelector('cart-drawer.active:not(.is-empty)');
      const checkout = drawer ? drawer.querySelector('#CartDrawer-Checkout') : document.getElementById('checkout');
      if (checkout && checkout.getClientRects().length) {
        const button = checkout.getBoundingClientRect();
        if (button.top < innerHeight && button.bottom > 0) {
          // Keep the entire fixed drawer footer clear, including totals and discounts.
          const footer = drawer && drawer.querySelector('.drawer__footer');
          watch(footer || checkout);
          const boundary = footer ? footer.getBoundingClientRect().top : button.top;
          const horizontallyOverlaps = baseLeft < button.right && baseLeft + rect.width > button.left;
          if (horizontallyOverlaps) {
            nextLift = Math.max(0, baseBottom - boundary + 12);
            if (drawer) nextShift = button.left - baseLeft;
          }
        }
      }
    }
    if (nextLift !== lift || nextShift !== shift) {
      lift = nextLift;
      shift = nextShift;
      teaser.style.setProperty('--fp-cart-teaser-y', `${-lift}px`);
      teaser.style.setProperty('--fp-cart-teaser-x', `${shift}px`);
    }
  }

  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(schedule).observe(drawer, {attributes: true, attributeFilter: ['class']});
    drawer.addEventListener('transitionend', schedule);
    watch(drawer);
  }
  addEventListener('resize', schedule, {passive: true});
  addEventListener('scroll', schedule, {passive: true, capture: true});
  media.addEventListener('change', schedule);
  schedule();
})();
